import { render, staticRenderFns } from "./ManageEvent.vue?vue&type=template&id=25d6ff48&scoped=true&"
import script from "./ManageEvent.vue?vue&type=script&lang=ts&"
export * from "./ManageEvent.vue?vue&type=script&lang=ts&"
import style0 from "./ManageEvent.vue?vue&type=style&index=0&id=25d6ff48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6ff48",
  null
  
)

export default component.exports